class TieredMenu extends HTMLElement {
  constructor() {
    super();
    this.pageLoadLinks = this.querySelectorAll('[data-prefetch="page-load"] a');
    this.hoverLinks = this.querySelectorAll('[data-prefetch="hover"] a');
  
    if (this.pageLoadLinks) this.handlePageLoadLinks();
    if (this.hoverLinks) this.handleHoverLinks();
  }

  async fetchPageContent(url) {
    if (localStorage.getItem(url)) return;
    
    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const mainContent = doc.querySelector('main') ? doc.querySelector('main').innerHTML : html;
      localStorage.setItem(url, mainContent);
    } catch (error) {
      console.error('Failed to prefetch page', error);
    }
  }

  loadPageContent(event, url) {
    event.preventDefault();
    const cachedContent = localStorage.getItem(url);

    if (cachedContent) {
      document.querySelector('main').innerHTML = cachedContent;
      window.history.pushState({}, '', url);
    } else {
      window.location.href = url;
    }
  }

  async handlePageLoadLinks() {
    for (const link of this.pageLoadLinks) {
      const url = link.href;
      
      await this.fetchPageContent(url);

      link.addEventListener('click', (event) => {
        this.loadPageContent(event, url);
      });
    }
  }

  handleHoverLinks() {
    this.hoverLinks.forEach(link => {
      const url = link.href;

      link.addEventListener('mouseover', () => {
        this.fetchPageContent(url);
      });

      link.addEventListener('click', (event) => {
        this.loadPageContent(event, url);
      });
    });
  }
}

customElements.define('tiered-menu', TieredMenu);
